import { render, staticRenderFns } from "./Adduser.vue?vue&type=template&id=ef5c6532&scoped=true&"
import script from "./Adduser.vue?vue&type=script&lang=js&"
export * from "./Adduser.vue?vue&type=script&lang=js&"
import style0 from "./Adduser.vue?vue&type=style&index=0&id=ef5c6532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5c6532",
  null
  
)

export default component.exports